var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLeichteSprache(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 321 321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-1{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 160.5,
    cy: 160.5,
    r: 160.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 160,
    cy: 66.77,
    r: 42.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.86,291.69C207.79,268.36,247,250.19,276.11,246V98.9c-29.18,2.21-68.2,19.06-111.25,41.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.14,291.69C112.21,268.36,73,250.19,43.89,246V98.9c29.18,2.21,68.2,19.06,111.25,41.91Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeichteSprache);
export default __webpack_public_path__ + "static/media/icon_leichte-sprache.7676a09793bcaa3c0f7611cbfc22d9be.svg";
export { ForwardRef as ReactComponent };